import { v2_fetchCmsPage } from '@crocodille/common';
import React from 'react';
import styles from './cms-page-content.module.scss';

interface Props {
  cmsPage: NonNullable<Awaited<ReturnType<typeof v2_fetchCmsPage>>>;
}

export const CmsPageContent: React.FC<React.PropsWithChildren<Props>> = ({
  cmsPage,
}) => (
  <>
    <div className={styles.container}>
      <h1 className={styles.header}>{cmsPage.name}</h1>
      <div
        className={styles.wrapper}
        dangerouslySetInnerHTML={{ __html: cmsPage.content || '' }}
      />
    </div>
  </>
);
